(() => {
  const parseVideo = (media) => {
    const provider = (media.dataset.provider || '').trim();
    const id = (media.dataset.videoId || '').trim();
    if (provider && id) return { provider, id };

    const url = (media.dataset.videoUrl || '').trim();
    if (!url) return null;

    const youtube = url.match(
      /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([\w-]{6,})/
    );
    if (youtube) return { provider: 'youtube', id: youtube[1] };

    const vimeo = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (vimeo) return { provider: 'vimeo', id: vimeo[1] };

    return null;
  };

  const buildSrc = ({ provider, id }, autoplay) => {
    if (provider === 'vimeo') {
      const params = ['api=1', 'playsinline=1'];
      if (autoplay) params.push('autoplay=1', 'muted=1');
      return `https://player.vimeo.com/video/${id}?${params.join('&')}`;
    }

    const params = ['enablejsapi=1', 'playsinline=1', 'rel=0', 'modestbranding=1'];
    if (autoplay) params.push('autoplay=1', 'mute=1');
    return `https://www.youtube.com/embed/${id}?${params.join('&')}`;
  };

  const initRecap = (root) => {
    if (root.dataset.leRecapReady === 'true') return;
    root.dataset.leRecapReady = 'true';

    const media = root.querySelector('[data-le-recap-media]');
    const frame = media && media.querySelector('[data-le-recap-frame]');
    const video = media ? parseVideo(media) : null;
    if (!media || !frame || !video) return;

    const autoplay = media.dataset.autoplay === 'true';
    const iframe = document.createElement('iframe');
    iframe.src = buildSrc(video, autoplay);
    iframe.title = 'Event recap video';
    iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
    iframe.setAttribute('allowfullscreen', 'allowfullscreen');
    iframe.loading = autoplay ? 'eager' : 'lazy';
    frame.appendChild(iframe);
    media.classList.add('is-ready');
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-le-recap]').forEach(initRecap);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
